export var TethysAppName = "airqualitybt";

export var TethysAPIAppName = "airqualitybt";

export let threddDataSource = "https://aqd.systems.gov.bt/thredds/"; //to be replaced with public ip later

export let GeoServerHost = "https://smog.icimod.org";

export var DefaultMaskWMS = false;

export var DefaultPlotInfo = {
  colorScheme: "jet",
  BBOX: [60, 15, 110, 40],
  tickSpan: 10,
  Resolution: 600,
  width: 12,
  height: 9,
};
